// extracted by mini-css-extract-plugin
module.exports = {"imageFigure":"Image_imageFigure__1YO8y","imageFigureCaption":"Image_imageFigureCaption__3pl11","imageFigureLoading":"Image_imageFigureLoading__1P8Gz"};